import React from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
import '../components/components.css';

const AiVoiceChanger = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2>AI Voice Changer</h2>
      <p>Transform your voice with cutting-edge AI technology.</p>
      
      <Card className="my-4 p-4 beats-card">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Upload Voice Recording</Form.Label>
            <Form.Control type="file" accept="audio/*" className="beats-form-control" />
            <Form.Text className="text-muted beats-form-text">
              Upload your voice recording (MP3, WAV, M4A)
            </Form.Text>
          </Form.Group>
          
          <div className="text-center my-4">
            <Button variant="outline-primary" className="rounded-circle p-3 mx-2 beats-btn-outline">
              <FontAwesomeIcon icon={faMicrophone} size="2x" />
            </Button>
            <div className="my-2">
              <small className="beats-form-text">or Record Directly</small>
            </div>
          </div>
          
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Voice Effect</Form.Label>
            <Form.Select aria-label="Voice effect" className="beats-form-select">
              <option>Robotic</option>
              <option>Deep Voice</option>
              <option>Helium</option>
              <option>Alien</option>
              <option>Ghostly</option>
              <option>Child Voice</option>
              <option>Elder Voice</option>
              <option>Auto-Tune</option>
            </Form.Select>
          </Form.Group>
          
          <Row className="mb-4">
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Pitch Shift</Form.Label>
                <Form.Range min="-12" max="12" defaultValue="0" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">Lower</small>
                  <small className="beats-form-text">Normal</small>
                  <small className="beats-form-text">Higher</small>
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Effect Intensity</Form.Label>
                <Form.Range min="0" max="100" defaultValue="50" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">Subtle</small>
                  <small className="beats-form-text">Strong</small>
                </div>
              </Form.Group>
            </Col>
          </Row>
          
          <Button variant="primary" type="submit" className="mb-3 beats-btn-primary">
            Apply Voice Effect
          </Button>
          
          <div className="mt-4 p-3 bg-dark rounded">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faVolumeHigh} className="me-3" />
              <div className="w-100">
                <div className="d-flex justify-content-between mb-1">
                  <small className="beats-form-text">Transformed Voice Preview</small>
                  <small className="beats-form-text">0:00 / 0:30</small>
                </div>
                <div className="progress beats-progress" style={{ height: '8px' }}>
                  <div className="progress-bar" role="progressbar" style={{ width: '0%' }}></div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Card>
    </Container>
  );
};

export default AiVoiceChanger; 